import React from "react";
import {Row, Col, BackTop} from "antd";
import { template, setLocalStorage } from "@reco-m/core";
import { ViewComponent, Banner, ImageAuto } from "@reco-w/core-ui";
import { Namespaces, financingModel } from "@reco-w/financing-models";
import { Consulting } from "src/apps/consulting/consulting";

export namespace Financing {

    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> {}

    export interface IState extends ViewComponent.IState, financingModel.StateType {}

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        showloading = false;
        namespace = Namespaces.financing;

        componentMount() {
            window.scroll(0, 0);
            setLocalStorage("selectedMenu", `/financing`);
        }
        componentDidMount() {
        }

        renderResource() {
            return (
                <div className="block-content trz-info-content">
                    <div className="container">
                        <div className="company-info">
                            <i className="icon iconyinhao1" />
                            为解决企业融资难的问题，瑞谷云企通过对接银杏谷资本、软银资本、宽带资本、英诺天使等合作投资机构，以及瑞谷FA专业团队，为企业提供金融服务精准对接，及时帮助企业解决融资难问题，促进企业发展壮大。
                        </div>
                    </div>
                </div>
            )
        }

        renderService() {
            const serviceData = [
                {
                    imgUrl: "assets/images/second/trz-bg1.jpg",
                    title: "融资方案定制",
                    desc: [
                        "针对项目所处阶段、行业，制定本轮可行的融资案例",
                        "可视化梳理项目亮点，精炼表述符合投资人评审习惯",
                        "提供行业趋势、竞品分析及市场一手数据分析的底层逻辑",
                        "针对项目潜在风险提出可行性解决方案，优化投资价值"
                    ]
                },
                {
                    imgUrl: "",
                    title: "财务模型搭建",
                    desc: [
                        "梳理企业发展核心业务数据，罗列核心价值板块，突出财务亮点",
                        "形成财务汇报表单，强调财务数据的优异性",
                        "针对核心业务，基于行业增速，参照竞品公司财务结构搭建未来3年财务预测",
                        "业务与财务的互相印证，为投资人提供有效的投资价值测算"
                    ]
                },
                {
                    imgUrl: "",
                    title: "精准推荐投资人",
                    desc: [
                        "对企业行业进行多个关键词定位",
                        "合作的投资机构范围涵盖:智能制造、新能源、新材料、大消费、大健康、汽车及零部件制造、工业制造、信息技术等;",
                        "对企业所处的融资阶段进行定位;",
                        "合作的投资机构投资阶段涵盖:天使轮、A轮、B轮、C轮、Pre-IPO轮。"
                    ]
                },
                {
                    imgUrl: "assets/images/second/trz-bg2.jpg",
                    title: "1V1闭门路演",
                    desc: [
                        "路演前进行路演ppt的演讲指导;",
                        "提供与投资人沟通的技巧指导;",
                        "联系高匹配的投资人进行闭门形式的1V1线下沟通。"
                    ]
                }
            ]
            return (
                <div className="block-content trz-service-content">
                    <div className="container">
                        <div className="second-title">
                            <span>投融资服务</span>
                        </div>
                        <Row className="trz-service-grid">
                            {
                                serviceData.map((item, i) => {
                                    return (
                                        <Col xs={24} sm={24} md={12} lg={12} key={i}>
                                            <div className="trz-service-grid-item">
                                                {item.imgUrl.length > 0 && <ImageAuto.Component src={item.imgUrl} width="100%" height="100%" />}
                                                <div className="trz-service-word">
                                                    <div className="size-28 text-center">{item.title}</div>
                                                    <div className="size-20 mt20">
                                                        {
                                                            item.desc.map((desc, j) => {
                                                                return (
                                                                    <Row key={j}>
                                                                        <Col span={1} className="text-yellow">-</Col>
                                                                        <Col span={23}>{desc}</Col>
                                                                    </Row>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </div>
                </div>
            )
        }

        renderProcess() {
            const processData = [
                {
                    number: 1,
                    icon: "assets/images/second/trz-icon1.png",
                    title: <>专业顾问<br />项目梳理</>
                },
                {
                    number: 2,
                    icon: "assets/images/second/trz-icon2.png",
                    title: <>融资方案<br />定制</>
                },
                {
                    number: 3,
                    icon: "assets/images/second/trz-icon3.png",
                    title: <>财务模型<br />搭建</>
                },
                {
                    number: 4,
                    icon: "assets/images/second/trz-icon4.png",
                    title: <>商业计划书<br />撰写</>
                },
                {
                    number: 5,
                    icon: "assets/images/second/trz-icon8.png",
                    title: <>精准推荐<br />投资人</>
                },
                {
                    number: 6,
                    icon: "assets/images/second/trz-icon7.png",
                    title: <>1V1<br />闭门路演</>
                },
                {
                    number: 7,
                    icon: "assets/images/second/trz-icon6.png",
                    title: <>项目<br />推荐与反馈</>
                },
                {
                    number: 8,
                    icon: "assets/images/second/trz-icon5.png",
                    title: <>持续<br />跟进对接</>
                }
            ]
            return (
                <div className="block-content trz-process-content">
                    <div className="container">
                        <div className="second-title">
                            <span>服务流程</span>
                        </div>
                        <Row className="trz-process-grid" gutter={[50,70]}>
                            {processData.map((item, i) => {
                                return (
                                    <Col xs={12} sm={12} md={6} lg={6} key={i}>
                                        <div className="trz-process-item">
                                            <div className="trz-process-number">{item.number}</div>
                                            <div className="trz-process-icon"><img src={item.icon} /></div>
                                            <div className="size-24 mt20 trz-process-title">
                                                {item.title}
                                            </div>
                                        </div>
                                    </Col>
                                )
                            })}
                        </Row>
                    </div>
                </div>
            )
        }

        renderConsult() {
            return <Consulting.Page renderType={1} orderCode="guanwcyzs"></Consulting.Page>
            // return (
            //     <div className="block-content consult-content">
            //         <div className="container">
            //             <div className="second-title line-no white-color">
            //                 <span>立即咨询定制方案</span>
            //             </div>
            //             <div className="consult-form">
            //                 <div className="consult-form-item">
            //                     <Input placeholder="请输入您的姓名" />
            //                 </div>
            //                 <div className="consult-form-item">
            //                     <Input placeholder="请输入您的单位" />
            //                 </div>
            //                 <div className="consult-form-item">
            //                     <Input placeholder="请输入您的联系方式" />
            //                 </div>
            //                 <div className="consult-form-item">
            //                     <Button type="primary" ghost block shape="round">立即咨询</Button>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            // )
        }

        renderBody() {
            return (
                <>
                    <div className="content">
                        <Banner.Component extraClass="large" bimg="assets/images/banner/trz-banner.jpg" cimg="" text={
                            <div className="home-banner-text">
                                <div className="banner-text-name1">投融资</div>
                                <div className="banner-text-name2 mt25">
                                    帮助企业解决融资难题
                                </div>
                            </div>}
                        />
                        {this.renderResource()}
                        {this.renderService()}
                        {this.renderProcess()}
                        {this.renderConsult()}
                        <div className="scoll-top">
                            <BackTop visibilityHeight={50} />
                        </div>
                    </div>
                </>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.financing]);
}
